import { COLOR_BORDER_LIGHT } from "./colors";

/**
 * @fileOverview Borders used in .js and .jsx files need to be standardized
 * using the values contained in this file.
 *
 * PLEASE TO NOT ADD TO OR CHANGE VALUES IN THIS FILE WITHOUT SPEAKING TO THE
 * LEAD ON INTERFACE DESIGN.
 */
export const BORDER_RADIUS = `2px`;
export const BORDERED_LIGHT = `1px solid ${COLOR_BORDER_LIGHT}`;
